export const TABS = {
  GENERAL_INFORMATION: "GENERAL_INFORMATION",
  FEEDBACK_FORM: "FEEDBACK_FORM",
  QUESTIONNAIRE: "QUESTIONNAIRE",
};

export const TABS_BUTTONS = [
  {
    title: "General Information",
    key: TABS.GENERAL_INFORMATION,
  },
  {
    title: "Questionnaire",
    key: TABS.QUESTIONNAIRE,
    allowCategories: ["Intervention", "Follow Up", "Safety", "Survey"],
    showCategory: true,
  },
  {
    title: "Feedback Form",
    key: TABS.FEEDBACK_FORM,
    allowCategories: ["Intervention Call"],
    showCategory: false,
  },
];

export const SORTED_GENERAL_KEYS = [
  "priority",
  "routineId",
  "assignedBy",
  "assignedTo",
  "assignedToName",
  "comments",
  "plannedVisitDatetime",
  "updatedAt",
  "updatedBy",
];
export const SORTED_CUSTOMER_KEYS = ["name", "id", "status", "phone", "location"];
